// extracted by mini-css-extract-plugin
export default {"container":"styles_container__l1LLK","title":"styles_title__wqItM","order":"styles_order__U252Y","buttons":"styles_buttons__Blp7b"};